var React = require('react');
var Radium = require('radium');
var ReactRouter = require('react-router');

var { Link } = ReactRouter;

var style = {
	link: {
		color: '#222'
	}
};

module.exports = Radium(React.createClass({

    render: function() {
    	var me = this, styleLink = style.link;

    	if (me.props.style) {
    		styleLink = Object.assign({}, 
    			style.link,
    			me.props.style
    		);
    	}

    	return <Link {...this.props} style={styleLink}/>
	}

}));


// WEBPACK FOOTER //
// ./src/components/NavLink.jsx